import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { Link, useNavigate } from 'react-router-dom'
import * as auth from "infra/localStorage.js"
import server from 'infra/server.js'
import LoginService from './loginService'
import { errorToToast } from 'helper/error'

export default function BaseDados() {

    const [baseDados, setBaseDados] = useState([])
    const [loginService] = useState(new LoginService())
    const navigate = useNavigate()
    const toast = useRef(null)
    let selected = ''

    const defaultValues = []
    const form = useForm({ defaultValues })
    const errors = form.formState.errors

    const [loading, setLoading] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768 || window.innerHeight < 420)

    useEffect(() => {
        document.body.style.backgroundColor = '#ffffff'
        return () => {
            document.body.style.backgroundColor = ''
        }
    }, [])

    // Depois de montada a tela.
    useEffect(() => {

        server().get('basedados')
            .then((response) => {
                setBaseDados(response.data)
            })

    }, [])

    // Salva.
    const onSubmit = () => {

        setLoading(true)

        server().post('basedados', { "codnum_bad": selected }
        ).then(() => {

            const storageData = auth.getData()

            /**
             * Agora vamos ver se a empresa está definida no servidor.
             */

            server().get('sessaoinfo')
                .then(async (response) => {
                    const dataInfo = response.data[0]

                    storageData.base.codnum_bad = dataInfo.codnum_bad
                    storageData.base.descricao_bad = dataInfo.descricao_bad
                    storageData.empresa.codigo_emp = dataInfo.cod_emp_ten_log_ses
                    storageData.menu = await loginService.getMenu()
                    storageData.bucketPath = dataInfo.bucketPath
                    auth.setData(storageData)

                    if (storageData.empresa.codigo_emp) {
                        // Busca a descrição da empresa
                        server().get('empresa').then((response) => {

                            const selectEmp = response.data.find((e) => e.codigo_emp == storageData.empresa.codigo_emp)
                            storageData.empresa.nome_razao_pes = selectEmp.nome_razao_pes
                            storageData.empresa.nome_fantasia_pej = selectEmp.nome_fantasia_pej
                            auth.setData(storageData)

                            navigate('/')

                        })
                    } else {
                        navigate('/empresa')

                    }
                    form.reset()

                }).catch(err => {
                    errorToToast({ err, toast, alt: 'Erro desconhecido ao selecionar Base!' })
                    setLoading(false)
                })

        }).catch(err => {
            errorToToast({ err, toast, alt: 'Erro desconhecido ao selecionar Base!' })
            setLoading(false)
        })

    }

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>
    }

    return (
        <div id='basedados' className="flex flex-column md:flex-row bg-white h-screen">

            {/* Esquerda: Branding */}
            {isMobile ? (
                <></>
            ) : (
                < div className="md:w-6 border-0" >
                    <img src="/login-sup-esq.svg" className='border-0' alt="Arte superior esquerda" />
                    <div className='flex border-0 absolute' style={{ top: '50%', left: '25%' }}>
                        <img src="/logo.svg" className='' alt="Logo" style={{ width: '15%' }} />
                        <div>
                            <div className='text-7xl ml-4'>Fiz Aqui</div>
                            <div className='ml-5 mt-1 text-gray-400'>Enterprise Resource Planning</div>
                        </div>
                    </div>
                </div>
            )}

            {/* Direita: Formulário */}
            <div className={`border-0 w-full md:w-${isMobile ? 12 : 6} flex flex-column align-items-center`}>

                {/* Cabeçalho */}
                <div className="border-0 pb-8 border-green-500 p-0 w-full flex flex-column align-items-end relative">

                    <img className="absolute" src="/login-sup-dir.svg" alt="Arte superior direira" />
                    <div className="absolute flex flex-nowrap mt-2 mr-4 ext-white text-lg">
                        <Link id='redefinePassword' to="/redefinirsenha" className="text-white no-underline">Esqueci minha senha</Link>
                        <div className='mx-2 text-white'>|</div>
                        <Link id='addExtraBase' to="/adicionabaseextra" className="text-white no-underline">Adicionar base</Link>
                    </div>

                </div>
                {/* Formulário */}
                <div className="border-0 border-round h-full w-full flex flex-column align-items-center justify-content-center">
                    <div className='flex flex-column border-0 shadow-0 justify-content-center align-items-center border-round-2xl bg-white w-20rem'>

                        <Toast ref={toast} />
                        <h2 className="flex flex-row justify-content-start align-items-center text-900 mb-4">
                            <img src="/logo.svg" className='' alt="Logo" style={{ width: '9%' }} />
                            <div className='ml-2 font-light'>Selecione uma Base</div>
                        </h2>
                        <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-column align-items-left">

                            {baseDados.map((e, index) => {
                                return <Controller
                                    key={index}
                                    name={e.descricao_bad}
                                    control={form.control}
                                    rules={{ required: false }}
                                    defaultValue=""
                                    render={(form) => (
                                        <>
                                            <Button itemID='butBasedados' key={form.field.name} label={form.field.name} type="submit" onClick={_ => selected = e.codnum_bad} id={form.field.name} {...form.field}
                                                icon={loading ? "pi pi-spin pi-cog" : "pi pi-database"}
                                                className="w-full font-bold bg-logo-main border-logo-main line-height-4 text-white border-2 border-solid border-round-2xl w-20rem"
                                            />
                                            {getFormErrorMessage(form.field.name)}
                                        </>
                                    )}
                                />
                            })}

                            {/* <Button label="Registrar-se" type="submit" icon="pi pi-check" /> */}
                            {/* onClick={setSelected(field.name)} */}

                            {/* Links adicionais */}
                            <div className="text-right mt-4">
                                <Link id='login' to="/login" className="text-logo-main no-underline">Acessar com outra conta</Link>
                            </div>

                        </form>

                    </div>

                </div>

            </div>

        </div>

    )

}
